import { Routes, Route } from "react-router-dom";
import Footer from "./components/Footer/Footer";
import Layout from "./components/Layout/Layout";
import Hero from "./components/Hero/Hero";
import Amenities from "./pages/Amenities/Amenities";
import Contact from "./pages/Contact/Contact";
import Gallery from "./pages/Gallery/Gallery";
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import Legal from "./pages/Legal/Legal";
import TermsAndConditions from "./pages/Legal/TermsAndConditions";
import ScrollToTop from "./components/Helper/ScrollToTop";
import ContactMap from "./pages/Contact/ContactMap";
import Menu from "./pages/Menu/Menu";
import WeddingPackagesSection from "./pages/Package/WeddingPackagesSection";
import RouteSEO from "./components/Common/RouteSEO";
import AboutUs from "./pages/AboutUs/AboutUs";
import SpecialOffersSection from "./pages/Offers/SpecialOffersSection";
import RoomsSection from "./pages/Rooms/RoomsSection";
import { ErrorBoundary } from "react-error-boundary";
import LoginIndex from "./pages/Login/LoginIndex";
import LoginState from "./context/LoginState";
import PrivateRoutes from "./components/routes/PrivateRoutes";
import { PersistLogin } from "./pages/Login/PersistLogin";
import CustomerSearch from "./pages/CustomerSearch/CustomerSearch";

function App() {
  return (
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <div style={{ textAlign: "center", marginTop: "100px" }}>
          <h2>Something went wrong</h2>
          <p>{error.message}</p>
          <button onClick={resetErrorBoundary}>Try again</button>
          <br />
          <button onClick={() => (window.location.href = "/")}>
            Go to login page
          </button>
        </div>
      )}
      onReset={() => window.location.reload()}
    >
      <LoginState>
        <ScrollToTop />
        <RouteSEO />

        <Routes>
          {/* Public */}
          {/* Layout wrapper */}

          <Route element={<Layout />}>
            <Route path="/" element={<Hero />} />
            {/* <Route path="/login" element={<LoginIndex />} />
            <Route path="/home" element={<Hero />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/contactMap" element={<ContactMap />} />
            <Route path="/Menu" element={<Menu />} />
            <Route path="/wedding-packages" element={<WeddingPackagesSection />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/offers" element={<SpecialOffersSection />} />
            <Route path="/rooms" element={<RoomsSection />} />
            <Route path="/amenities" element={<Amenities />} /> */}


            {/* Persist login */}
            <Route element={<PersistLogin />}>
              {/* Protected */}
              <Route element={<PrivateRoutes allowedRoles={[1, 2, 3]} />}>


                {/* <Route path="/home" element={<Hero />} /> */}
                
                 <Route path="/CustomerSearch" element={<CustomerSearch />} />

              </Route>

            </Route>
          </Route>
        </Routes>
      </LoginState>
    </ErrorBoundary>
  );
}

export default App;